import React, { useEffect, useState } from "react";
import { FormControl, TextField, Grid, Alert } from '@mui/material';
import ModalFooter from "../Modal/ModalFooter/ModalFooter";
import axios from 'axios';
import ModalHeader from "../Modal/ModalHeader/ModalHeader";

export default function StepFour(props) {
    const [response, setResponse] = useState(false);
    const [dataResponse, setDataResponse] = useState();
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': submitDatas,
                'text': 'Je signe la pétition',
                'disabled': true,
                'color': 'success',
                'datas': props.datas
            }
        ]);

    useEffect(() => {
        if (props.datas.email && props.datas.nom && props.datas.prenom) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        buttons[1].datas = props.datas;
        setButtons([...buttons]);
    }, [props.datas]);

    function submitDatas(datas) {
        setResponse(false);
        const instanceOfAxios = axios.create({ baseURL: "https://preprod.www.class-appart.com.web09.ovea.com/api/api" })
        instanceOfAxios.post('/admin/petition', { datas: datas })
            .then(res => {
                setDataResponse({ text: res.success, color: 'success' });
                setResponse(true);
                setTimeout(() => {
                    props.handleClose(false);
                }, 3000);
            })
            .catch(err => {
                let text = 'Une erreur c\'est produite merci de reéssayer ultérieurement';
                if (err.error == 'Vous avez déjà signé cette pétition') {
                    text = err.error;
                }
                setDataResponse({ text: text, color: 'error' });
                setResponse(true);
            })
    }

    const handleChange = (e) => {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <ModalHeader text="Pétition:" secondText="Contre le règlement encadrant les changements d'usage pour les meublés de tourisme Montpellierains" />
            <Grid container>
                <Grid item>
                    <p>Nous demandons à monsieur le Maire de protéger les commerçants du centre ville, les emplois et les entreprises bénéficiants des retombées économiques liées aux locations meublées de courtes et moyennes durées faites dans la ville de Montpellier.</p>
                    <p>Pour ce faire, nous lui demandons de revoir le règlement encadrant les changements d'usage des locaux d'habitation réalisés sur le territoire de la ville de Montpellier, après délibération en date du 28 Juillet 2021.</p>
                    <p>Nous l’invitons également à rencontrer notre association, les commerçants, les citoyens et les entreprises impactés par cette décision prise sans consultation préalable.</p>
                </Grid>
                <Grid item xs={12}>
                    <FormControl component="fieldset" sx={{ width: '100%' }}>
                        <TextField
                            id="outlined-password-input"
                            label="Nom"
                            type="text"
                            size='small'
                            name='nom'
                            autoComplete="current-password"
                            onChange={handleChange}
                            sx={{ margin: '1vh' }}
                        />
                        <TextField
                            id="outlined-password-input"
                            label="Prénom"
                            type="text"
                            size='small'
                            name='prenom'
                            autoComplete="current-password"
                            onChange={(e) => handleChange(e)}
                            sx={{ margin: '1vh' }}
                        />
                        <TextField
                            id="outlined-password-input"
                            label="Email"
                            type="email"
                            size='small'
                            name='email'
                            autoComplete="current-password"
                            onChange={handleChange}
                            sx={{ margin: '1vh' }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} justifyContent='center' direction='row' sx={{ display: 'flex' }}>
                    {
                        response &&
                        <Alert severity={dataResponse.color}>{dataResponse.text}</Alert>
                    }
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}